import script from "./BackToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./BackToTop.vue?vue&type=script&setup=true&lang=js"

import "./BackToTop.vue?vue&type=style&index=0&id=83674218&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83674218"]])

export default __exports__